module.exports = __webpack_public_path__ + "img/jx.64d34d00.png";